import ContentZone from "hub/src/components/common/ContentZone";
import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";

export const HubCheckoutContent = () => {
  const { routeConfig } = useHubCheckoutContext();
  return (
    <div className="p-2">
      <ContentZone
        appRouteConfigId={routeConfig.id!}
        contentPages={routeConfig.contentPage ?? []}
        zone={"main"}
      />
    </div>
  );
};
